import { Status } from "src/core/constants/folders";
import { useRequiredTenantPaths } from "src/core/hooks/routing/useTenantPaths";

type BuildArgs = {
  id: string;
  status?: Status;
};

/**
 * Génère le chemin d'un dossier en fonction de la marque et du statut.
 * Si on est sur la marque notaire, on redirige vers le résumé du dossier.
 * Si on est expert-comptable et pour les dossiers sensibles ou en validation, on redirige vers l'onglet cartographie,
 * sinon on redirige vers le dossier.
 */
export const useFolderNavigationStrategy = () => {
  const paths = useRequiredTenantPaths();

  const buildFolderPath = ({ id, status }: BuildArgs) => {
    const base = paths.folder(id);
    if (status && [Status.VALIDATION_PENDING, Status.VALIDATION_PENDING_HR].includes(status)) {
      return `${base}?tab=cartographie`;
    }
    return base;
  };

  return {
    buildFolderPath,
  };
};
